import { http } from '../../../shared/services/http.service';
import type { MeResponse } from '../models/auth.model';

export const authService = {
  me: (): Promise<MeResponse> => http.get<MeResponse>('/api/auth/me'),
  exchange: (token: string): Promise<MeResponse> => http.post<MeResponse>('/api/auth/exchange', { token }),
  logout: (): Promise<void> => http.post<void>('/api/auth/logout'),
};
